import { render, staticRenderFns } from "./tableInvite.vue?vue&type=template&id=a10d2826&scoped=true&slot-scope=scope&"
import script from "./tableInvite.vue?vue&type=script&lang=js&"
export * from "./tableInvite.vue?vue&type=script&lang=js&"
import style0 from "./tableInvite.vue?vue&type=style&index=0&id=a10d2826&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10d2826",
  null
  
)

export default component.exports